import "./index.css";
import "./Role.css";
import ambitionperson from "../../assets/shapes_svg/ambition/ambitionperson.svg";
const Role = ({ title }) => {
  return (
    <div
      className={
        "ambition__role__item " +
        (title === "Supply Chain"
          ? "role_background2"
          : title === "Logistics"
          ? "role_background3"
          : title === "Sales"
          ? "role_background4"
          : title === "I.T"
          ? "role_background5"
          : title === "Ownership & Board"
          ? "role_background6"
          : title === "HR"
          ? "role_background7"
          : title === "Admin"
          ? "role_background8"
          : title === "Marketing"
          ? "role_background9"
          : title === "Production"
          ? "role_background10"
          : null)
      }
    >
      <h5>{title}</h5>
      <img src={ambitionperson} alt="Person Icon" />
    </div>
  );
};

export default Role;
